import { ImageType } from "@/lib/getImageUrl";
import type { DeckResult } from "@/lib/queries/deckQueries";
import { capitalCase } from "change-case";
import { useImageContext } from "../ImageProvider/ImageContext";
import { MagicCommandItem } from "./MagicCommandItem";

interface Props {
	deck: DeckResult;
	onSelect: () => void;
	selected?: boolean;
}

export const DeckCommandItem: React.FC<Props> = ({
	deck,
	onSelect,
	selected,
}) => {
	const { getImageUrl } = useImageContext();

	const mainSize =
		(deck.deck_size?.mainboard || 0) + (deck.deck_size?.commander || 0);
	const sideSize = deck.deck_size?.sideboard || 0;

	return (
		<MagicCommandItem
			{...{
				title: deck.name,
				description: capitalCase(deck.format),
				colors: deck.colors || [],
				image: {
					alt: `Cover card for ${deck.name}`,
					src: deck.cover_card?.id
						? getImageUrl(deck.cover_card?.id, ImageType.ArtCrop)
						: "",
				},
				onSelect,
				selected,
				commandValue: deck.name,
				extra: (
					<div className="font-mono text-xs">
						{mainSize} / {sideSize}
					</div>
				),
			}}
		/>
	);
};
